export default __webpack_public_path__ + "static/media/Amealio_Illustrations-09.0ef70e95.png";